import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ px: 2 }}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          py: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: '100%',
            p: { xs: 3, sm: 4, md: 6 },
            textAlign: 'center',
            position: 'relative',
            borderRadius: { xs: 2, md: 4 },
            background:
              'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 100%)',
            backdropFilter: 'blur(10px)',
            border: '1px solid',
            borderColor: 'grey.100',
          }}
        >
          <Box
            component="img"
            src="/logo.svg"
            alt={t('app.title', 'SmartRisto')}
            sx={{
              width: { xs: 60, sm: 80, md: 100 },
              height: 'auto',
              mb: { xs: 2, sm: 3 },
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  transform: 'scale(1)',
                },
                '50%': {
                  transform: 'scale(1.05)',
                },
                '100%': {
                  transform: 'scale(1)',
                },
              },
            }}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: { xs: 1, sm: 2, md: 4 },
              mb: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '4rem', sm: '6rem', md: '10rem' },
                fontWeight: 900,
                lineHeight: 1,
                background:
                  'linear-gradient(to right, #F51F55, #F53034, #F69124)',
                backgroundClip: 'text',
                textFillColor: 'transparent',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 2px 10px rgba(0,0,0,0.1)',
              }}
            >
              {t('errors.not-found.title', '404')}
            </Typography>

            <SentimentVeryDissatisfiedIcon
              sx={{
                fontSize: { xs: '3rem', sm: '4rem', md: '6rem' },
                color: '#F51F55',
                animation: 'float 6s ease-in-out infinite',
                '@keyframes float': {
                  '0%, 100%': {
                    transform: 'translateY(0) rotate(0deg)',
                  },
                  '50%': {
                    transform: 'translateY(-20px) rotate(5deg)',
                  },
                },
              }}
            />
          </Box>

          <Typography
            variant="h4"
            sx={{
              maxWidth: '600px',
              mx: 'auto',
              mb: { xs: 3, md: 4 },
              color: 'text.secondary',
              fontWeight: 400,
              fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
              lineHeight: 1.4,
              px: { xs: 1, sm: 2 },
            }}
          >
            {t('errors.not-found.message')}
          </Typography>

          <Button component={Link} to="/" variant="contained" size="large">
            {t('errors.not-found.button')}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;
